/* src/app/merge/merge-presenter/merge-presenter.component.scss */
body#themeTag :host ::ng-deep .p-inline-message {
  width: 80%;
}
body#themeTag :host ::ng-deep .p-inline-message .p-inline-message-text {
  font-size: 1.25em !important;
}
body#themeTag :host ::ng-deep .p-inline-message.p-inline-message-success .p-inline-message-icon {
  font-size: 1.25em !important;
}
/*# sourceMappingURL=merge-presenter.component.css.map */
